import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, QuoteIcon, StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  city: string;
  text: string;
}
const TESTIMONIALS: Testimonial[] = [{
  name: 'María',
  city: 'Buenos Aires',
  text: 'Antes tardaba horas en preparar una clase. Hoy entro al estudio sabiendo exactamente qué voy a hacer.'
}, {
  name: 'Florencia',
  city: 'Córdoba',
  text: 'Lo que más me ayudó fueron las adaptaciones. Ahora cuando aparece una alumna con molestias sé cómo resolver la clase con seguridad.'
}, {
  name: 'Carolina',
  city: 'Rosario',
  text: 'Mis clases dejaron de sentirse improvisadas. Mis alumnas lo notaron enseguida.'
}, {
  name: 'Julieta',
  city: 'Mendoza',
  text: 'Las clases listas me ahorran muchísimo tiempo y me permiten enfocarme en enseñar mejor.'
}];
export function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const shouldReduceMotion = useReducedMotion();
  const testimonial = TESTIMONIALS[activeIndex];
  const showTestimonial = (index: number) => {
    if (index === activeIndex) return;
    setDirection(index > activeIndex ? 1 : -1);
    setActiveIndex(index);
  };
  const goToPrevious = () => {
    setDirection(-1);
    setActiveIndex(currentIndex => currentIndex === 0 ? TESTIMONIALS.length - 1 : currentIndex - 1);
  };
  const goToNext = () => {
    setDirection(1);
    setActiveIndex(currentIndex => (currentIndex + 1) % TESTIMONIALS.length);
  };
  const slideVariants = {
    enter: (slideDirection: number) => ({
      opacity: 0,
      x: shouldReduceMotion ? 0 : slideDirection * 24
    }),
    center: {
      opacity: 1,
      x: 0
    },
    exit: (slideDirection: number) => ({
      opacity: 0,
      x: shouldReduceMotion ? 0 : slideDirection * -24
    })
  };
  return <section className="w-full bg-beige-deep py-14 sm:py-16" data-id="element-160" data-mp="1nnv0m360m9w0">
      <div className="mx-auto w-full px-5 sm:w-[70%] sm:px-0" data-id="element-161" data-mp="1xhh5runo19l5">
        <div className="mx-auto max-w-xl text-center" data-id="element-162" data-mp="1siedlassaxul">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-brown-light" data-id="element-163" data-mp="1sgted7viyqqe">
            Opiniones reales
          </p>
          <h2 className="mt-3 font-serif text-3xl font-semibold leading-[1.08] text-brown-dark sm:text-4xl" data-id="element-164" data-mp="1jihq3ci4s514">
            Más de 1.500 profes ya enseñan con Pilates Resuelto
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-sm leading-relaxed text-brown-dark/70 sm:text-base" data-id="element-165" data-mp="19sequukf1uuc">
            Resultados que se sienten antes de empezar la próxima clase.
          </p>
        </div>

        <div className="mx-auto mt-7 max-w-lg" data-id="element-166" data-mp="10s021l88txm3">
          <div className="flex items-center justify-between px-1" aria-label="Navegación de opiniones" data-id="element-167" data-mp="10tb5fjxs13co">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-brown-dark/50" data-id="element-168" data-mp="vs3uxd491q2b">
              {String(activeIndex + 1).padStart(2, '0')} / {String(TESTIMONIALS.length).padStart(2, '0')}
            </p>
            <div className="flex gap-2" data-id="element-169" data-mp="32j0bj77frthg">
              <button type="button" onClick={goToPrevious} className="flex h-9 w-9 items-center justify-center rounded-full border border-brown-light/25 bg-white text-brown-dark transition-colors hover:bg-beige" aria-label="Ver opinión anterior" data-id="element-170" data-mp="37f7h2yvx72yv">
                <ChevronLeftIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-171" data-mp="2jrpmywp6nssq" />
              </button>
              <button type="button" onClick={goToNext} className="flex h-9 w-9 items-center justify-center rounded-full border border-brown-light/25 bg-white text-brown-dark transition-colors hover:bg-beige" aria-label="Ver opinión siguiente" data-id="element-172" data-mp="2oqankx8ckehp">
                <ChevronRightIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-173" data-mp="20xu36g150af8" />
              </button>
            </div>
          </div>

          <div className="relative mt-3 min-h-[262px] overflow-hidden rounded-2xl border border-brown-light/20 bg-white shadow-[0_12px_30px_rgba(94,67,50,0.08)]" data-id="element-174" data-mp="1lwn9l5zbs9t6">
            <div className="h-1 bg-brown-light/15" data-id="element-175" data-mp="1gzn16of06uyw">
              <motion.div className="h-full bg-brown-light" animate={{
              width: `${(activeIndex + 1) / TESTIMONIALS.length * 100}%`
            }} transition={{
              duration: shouldReduceMotion ? 0 : 0.25,
              ease: 'easeOut'
            }} data-id="element-176" data-mp="1vn81kakhug34" />
            </div>
            <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-177" data-mp="1zotd9slakobq">
              <motion.figure key={testimonial.name} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
              duration: shouldReduceMotion ? 0 : 0.24,
              ease: [0.25, 1, 0.5, 1]
            }} className="flex min-h-[258px] flex-col p-6 sm:p-7" data-id="element-178" data-mp="1zqo2hj3lj2lm">
                <div className="flex items-center justify-between" data-id="element-179" data-mp="2qw1vgr4sxk3k">
                  <QuoteIcon className="h-7 w-7 text-brown-light/45" data-id="element-180" data-mp="2qxwiqc3jpoat" />
                  <div className="flex text-brown-light" aria-label="5 de 5 estrellas" data-id="element-181" data-mp="2vud8faqe8aq0">
                    {Array.from({
                    length: 5
                  }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" strokeWidth={0} data-id="element-182" data-mp="2m4jxmby2rzmt" data-mpi={index} />)}
                  </div>
                </div>
                <blockquote className="mt-5 flex-1 font-serif text-xl leading-relaxed text-brown-dark sm:text-2xl" data-id="element-183" data-mp="287euoktnrgvs">
                  “{testimonial.text}”
                </blockquote>
                <figcaption className="mt-5 border-t border-brown-light/15 pt-4" data-id="element-184" data-mp="1y8pcss1rhwfj">
                  <p className="font-serif text-base font-semibold text-brown-dark" data-id="element-185" data-mp="2370lv0k8g2wp">
                    {testimonial.name}
                  </p>
                  <p className="mt-0.5 text-xs text-brown-dark/60" data-id="element-186" data-mp="3sjcf4lbbx4g3">{testimonial.city}</p>
                </figcaption>
              </motion.figure>
            </AnimatePresence>
          </div>

          <div className="mt-5 flex justify-center gap-2" role="tablist" aria-label="Elegir una opinión" data-id="element-187" data-mp="3w0qfsozkrnhc">
            {TESTIMONIALS.map((item, index) => <button key={item.name} type="button" role="tab" aria-selected={index === activeIndex} aria-label={`Ver opinión de ${item.name}`} onClick={() => showTestimonial(index)} className={`h-2 rounded-full transition-all duration-200 ${index === activeIndex ? 'w-6 bg-brown-dark' : 'w-2 bg-brown-light/35 hover:bg-brown-light/65'}`} data-id="element-188" data-mp="3m5ylbu1ahgqs" data-mpi={index} />)}
          </div>
        </div>
      </div>
    </section>;
}